import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import NavBar from "./NavBar";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { closePromptPackagesModal } from "../../app/promptsSlice";
import PromptsPackagesModal from "../Onboarding/PromptsPackagesModal";

function Layout() {
  const dispatch = useAppDispatch();
  const isPromptPackagesModalOpen = useAppSelector(
    (state: RootState) => state.prompts.isPromptPackagesModalOpen
  );

  const handleClosePackagesModal = () => {
    dispatch(closePromptPackagesModal());
  };

  return (
    <Box>
      <PromptsPackagesModal
        onClose={handleClosePackagesModal}
        open={isPromptPackagesModalOpen}
      />
      <NavBar />
      <Outlet />
    </Box>
  );
}

export default Layout;
